import { production, releaseName } from 'app/config/constants'
import { when } from 'mobx'
import { store } from 'store/store'
import { Meta } from 'type/Options'
import { postMessageSelf } from 'util/message'
import { omit, omitNil } from 'util/object'
import { delay } from 'util/promise'

function getParams(): Record<string, string | undefined> {
  const { w, dark, ...query } = Object.fromEntries(new URLSearchParams(location.search))
  const def: any = {
    product: '95e684b9-0d2a-4b0b-97d8-ac7a272f664e',
    item: '03d91942-17e9-4744-8261-eea19335246d',
    client: 'dresscode_partner_demo_widget_stage',
    stand: true,
    basic: true,
  }
  if (w != null) {
    def.window = {
      product_id: '05d8a020-af90-4761-9738-c72e7b7d61ef',
      group: '1f400af1-c1f8-4b13-b658-3503aca6b142',
    }
  }
  if (dark != null) {
    def.theme = 'dark'
  }
  return { ...omit(def), ...query }
}

function getEmail(): object | undefined {
  const { email } = getParams()
  return email == null ? undefined : { on: true }
}

function getSelfies(): object | undefined {
  const { selfies } = getParams()
  return selfies == null ? undefined : { on: true }
}

function getLikes(): object | undefined {
  const { likes } = getParams()
  return likes == null ? undefined : { on: true }
}

function getMeta(): Meta {
  return {
    location: location.href,
    self: true,
  }
}

function getBool(value: string | boolean | undefined): boolean | undefined {
  if (value === 'false' || value === false) return false
  if (value === 'true' || value === true || value === '') return true
  return undefined
}

function getOptions(): object {
  const params = getParams()
  const {
    product,
    client,
    company,
    access,
    user,
    turn,
    window,
    theme,
  } = params

  const email = getEmail()
  const inline = getBool(params.inline)
  const lang = params.ru != null ? 'ru' : params.en != null ? 'en' : params.lang ?? 'en'
  const likes = getLikes()
  const selfies = getSelfies()
  const stand = getBool(params.stand)
  const basic = getBool(params.basic)
  const tsum = getBool(params.tsum)
  const video = getBool(params.video)
  const combine = getBool(params.combine)
  const footer = getBool(params.footer)
  const boutique = getBool(params.boutique)
  const external = getBool(params.external)
  const camera = getBool(params.camera)
  const delete_allowed = getBool(params.delete_allowed)
  const hide_name_for_en = getBool(params.hide_name_for_en)
  const show_clothing_sizes = getBool(params.show_clothing_sizes)
  const webview = getBool(params.webview)

  return omitNil({
    product,
    client,
    access,
    company,
    email,
    inline,
    lang,
    likes,
    selfies,
    stand,
    basic,
    tsum,
    turn,
    user,
    video,
    combine,
    footer,
    boutique,
    external,
    camera,
    delete_allowed,
    hide_name_for_en,
    show_clothing_sizes,
    webview,
    window,
    theme,
  })
}

function getOpen(): object {
  const { item, combo_item_id, autostart } = getParams()
  return { item, combo_item_id, autostart }
}

function getMin(): boolean {
  const { min } = getParams()
  return min != null
}

function getMax(): boolean {
  const { max } = getParams()
  return max != null
}

async function go() {
  console.info('try on', releaseName)
  const options = getOptions()
  const meta = getMeta()
  const open = getOpen()
  const min = getMin()
  const max = getMax()
  postMessageSelf('setup', { options, meta })
  await when(() => store.setupDone)
  postMessageSelf('open', open)
  await delay(100)
  if (min) store.state = 'min'
  if (max) store.state = 'max'
}

export function test() {
  const { pathname } = location
  const test = !production && pathname === '/try'
  if (test) void go()
}
